export default "__VITE_ASSET__KgXdnMVd__"